






























































import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import {
  LanguageDto,
  ActivityDto,
  ActivityCommentDto
} from "@/server/app.dtos";
import { ActivitiesCommentsService } from "@/services/api/activities.comments.service";
import { CreateActivityCommentCommand } from "@/server/app.commands";
import { GetActivityCommentsDtosQuery } from "@/server/app.queries";
import { NotificationServiceBus } from "@/services/bus/notifications.service";
import { ListResponse } from "@/models/grids/list.response";

@Component
export default class ActivityDetailCommentsPage extends Vue {
  @Prop() activity!: ActivityDto;
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  activitiesCommentsService: ActivitiesCommentsService = new ActivitiesCommentsService();
  comment: CreateActivityCommentCommand = new CreateActivityCommentCommand();
  allComments: ActivityCommentDto[] = [];
  isLoading: boolean = false;
  isValid: boolean = false;

  async created() {
    await this.LoadComments();
  }

  async LoadComments() {
    if (this.isLoading) return;
    const query = new GetActivityCommentsDtosQuery();
    query.idLanguage = this.currentLanguage.idLanguage;
    query.idActivity = this.activity.idActivity;
    this.isLoading = true;
    await this.activitiesCommentsService
      .GetComments(query)
      .then((result: ListResponse<ActivityCommentDto>) => {
        this.allComments = result.data;
      })
      .catch((error: any) => NotificationServiceBus.showError(error))
      .finally(() => (this.isLoading = false));
  }

  async onCreateActivityComment() {
    if (this.isLoading) return;
    this.isLoading = true;
    this.comment.idActivity = this.activity.idActivity;
    await this.activitiesCommentsService
      .CreateComment(this.comment)
      .then(async () => {
        this.isLoading = false;
        NotificationServiceBus.showSuccessMessage(
          "Sucesso",
          "Operação efetuada com sucessso"
        );
        this.comment.message = "";
        this.comment.isPublic = false;
        (this.$refs.form as any).resetValidation();
        await this.LoadComments();
      })
      .catch((error: any) => {
        this.isLoading = false;
        NotificationServiceBus.showError(error);
      });
  }

  isEven(index: number): boolean {
    return index % 2 == 1;
  }
}
